import skeletonStyles from "./SkeletonCatalogo.module.css";

function SkeletonCatalogo() {
  return (
    <div className={skeletonStyles["skeleton-container"]}>
      <div className={skeletonStyles["skeleton-box"]} />
      <div className={skeletonStyles["skeleton-box"]} />
      <div className={skeletonStyles["skeleton-box"]} />
      <div className={skeletonStyles["skeleton-box"]} />
    </div>
  );
}

export default SkeletonCatalogo;
